import { render, staticRenderFns } from "./DialogMaskImage.vue?vue&type=template&id=329c84ce&scoped=true"
import script from "./DialogMaskImage.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogMaskImage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DialogMaskImage.vue?vue&type=style&index=0&id=329c84ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329c84ce",
  null
  
)

export default component.exports